export enum EventKeys {
  NewChat = 'NewChat',
  ChatSearch = 'ChatSearch',
  ChatHistory = 'ChatHistory',
}
